<template>
    <el-drawer
        v-model="drawer"
        title="eP2AS Licenses menu"
        direction="ltr"
        :size="260"
    >
        <el-menu class="w-100" router>
            <el-menu-item-group
                v-for="links in linkLists"
                :key="links.label"
                :title="links.label"
            >
                <el-menu-item
                    v-for="link in links.items"
                    :key="link.name"
                    :route="`/${link.path}`"
                    :index="link.name"
                    @click="drawer = false"
                >
                    {{ link.label }}
                </el-menu-item>
            </el-menu-item-group>
        </el-menu>
    </el-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    components: {},
    props: {
        openMenu: {
            type: Boolean,
            default: () => false,
        },
    },
    emits: ['toggle-menu'],
    data() {
        return {
            drawer: false,
            linkLists: [
                {
                    label: 'Licenses',
                    items: [
                        {
                            path: 'licenses',
                            name: 'Licenses',
                            label: 'Licenses',
                        },
                    ],
                },
                {
                    label: 'Resource Usages',
                    items: [
                        {
                            path: 'api-usages',
                            name: 'ApiUsages',
                            label: 'Api usages',
                        },
                        {
                            path: 'file-usages',
                            name: 'FileUsages',
                            label: 'File usages',
                        },
                    ],
                },
            ],
        };
    },
    watch: {
        openMenu(value) {
            this.drawer = value;
        },
        drawer(value) {
            this.$emit('toggle-menu', value);
        },
    },
});
</script>
